<template>
    
</template>

<script>
export default {  
    beforeMount() {
            this.$store.dispatch('logout')
            this.$router.push('/login')
    }
}
</script>